<template>
  <!-- 上传产品补充协议弹窗组件 -->
  <el-dialog title="上传产品补充协议" width="1100px" class="my-dialog-template agreement-dialog" :visible.sync="visible" top="0">
    <div class="agreement-tips">
      补充协议需满足：①加盖公章(不可为财务章)；②提供清晰PDF文件，单文件大小不超过20M。
    </div>

    <el-table ref="myTable" :data="tableData" style="width: 100%" border class="list-table" v-loading="listLoading">
      <!-- 序号列 -->
      <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>

      <!-- 保险公司名称列 -->
      <el-table-column prop="companyName" label="保险公司名称" min-width="200px" :show-overflow-tooltip="true"></el-table-column>

      <!-- 状态列 -->
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.checkStatus == -1" type="danger">驳回</el-tag>
          <el-tag v-if="row.checkStatus == 0" type="warning">审核中</el-tag>
          <el-tag v-if="row.checkStatus == -3" type="info">待上传</el-tag>
        </template>
      </el-table-column>

      <!-- 补充协议列 -->
      <el-table-column label="补充协议" width="120" align="center">
        <template slot-scope="{ row }">
          <a v-if="row.productAgreementUrl" class="link-text" @click="handleDownload(row)">协议下载</a>
          <span v-else>--</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="{ row }">
          <!-- 驳回状态：显示查看和重新上传 -->
          <template v-if="row.checkStatus == -1">
            <span class="link-text" @click="handleView(row)">查看</span>
            <span class="link-text ml-10" @click="handleUpload(row)">重新上传</span>
          </template>
          <!-- 待上传状态：显示上传文件 -->
          <template v-else-if="row.checkStatus == -3">
            <span class="link-text" @click="handleUpload(row)">上传文件</span>
          </template>
          <!-- 审核中状态：显示查看 -->
          <template v-else-if="row.checkStatus == 0">
            <span class="link-text" @click="handleView(row)">查看</span>
          </template>
        </template>
      </el-table-column>

      <!-- 备注列 -->
      <el-table-column prop="remark" label="备注" min-width="180px" :show-overflow-tooltip="true">
        <template slot-scope="{ row }">
          <span v-if="row.checkStatus == -1 && row.remark">{{ row.remark }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 隐藏的上传组件，用于触发文件选择 -->
    <el-upload
      ref="fileUpload"
      class="hidden-upload"
      :show-file-list="false"
      accept=".pdf"
      :before-upload="beforeUpload"
      :action="$config.api_root + '/resmgr/upload'"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
    >
    </el-upload>

    <!-- 查看协议文件弹窗 -->
    <el-dialog title="查看协议" width="900px" class="my-dialog-template view-agreement-dialog" :visible.sync="viewDialogVisible" top="0" append-to-body>
      <iframe v-if="viewDialogVisible && viewAgreementUrl" :src="viewAgreementUrl" style="width:100%;height:70vh;border:none;"></iframe>
    </el-dialog>
  </el-dialog>
</template>

<script>
/**
 * 上传产品补充协议弹窗组件
 * 用于展示保险公司补充协议列表，支持查看、上传、重新上传等操作
 */
export default {
  name: 'uploadAgreementModal',
  data() {
    return {
      // 弹窗显示状态
      visible: false,
      // 表格数据列表
      tableData: [],
      // 列表加载状态
      listLoading: false,
      // 当前操作的行数据
      currentRow: null,
      // 状态映射配置
      statusMap: {
        rejected: '驳回',
        pending: '待上传',
        reviewing: '审核中'
      },
      balanceIds: null,
      // 查看协议弹窗显示状态
      viewDialogVisible: false,
      // 查看协议的URL地址
      viewAgreementUrl: ''
    };
  },
  methods: {
    /**
     * 打开弹窗并加载数据
     */
    open(balanceIds) {
      this.balanceIds = balanceIds;
      this.visible = true;
      this.getList();
    },
    // 获取补充协议列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/master/means/queryCompanyProductAgreementList',
        type: 'put',
        params: {
          balanceIds: this.balanceIds
        }
      }).then(res => {
        this.listLoading = false;
        const list = res.data;
        list.forEach(item => {
          item.agreementUrl = item.fileUrl ? JSON.parse(item.fileUrl)[0]?.url : '';
        });
        this.tableData = list;
      });
    },

    /**
     * 获取状态文本
     * @param {string} status - 状态码
     * @returns {string} 状态文本
     */
    getStatusText(status) {
      return this.statusMap[status] || '--';
    },

    /**
     * 查看已上传的协议文件
     * @param {Object} row - 当前行数据
     */
    handleView(row) {
      if (row.agreementUrl) {
        this.viewAgreementUrl = row.agreementUrl;
        this.viewDialogVisible = true;
      } else {
        this.$message.warning('暂无上传文件');
      }
    },

    /**
     * 下载协议文件
     * @param {Object} row - 当前行数据
     */
    handleDownload(row) {
      if (row.productAgreementUrl) {
        this.$tools.daochu2(row.productAgreementUrl);
      } else {
        this.$message.warning('暂无上传文件');
      }
    },

    /**
     * 触发文件上传操作（点击重新上传或上传文件时调用）
     * @param {Object} row - 当前行数据
     */
    handleUpload(row) {
      this.currentRow = row;
      // 触发隐藏的上传组件的文件选择
      this.$refs.fileUpload.$refs['upload-inner'].handleClick();
    },

    /**
     * 上传前文件校验
     * @param {File} file - 上传的文件对象
     * @returns {boolean} 是否通过校验
     */
    beforeUpload(file) {
      // 校验文件类型是否为PDF
      const isPdf = file.type === 'application/pdf' || file.name.endsWith('.pdf');
      if (!isPdf) {
        this.$message.error('只能上传 PDF 文件');
        return false;
      }

      // 校验文件大小不超过20MB (20*1024*1024 = 20971520 bytes)
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB');
        return false;
      }

      return true;
    },

    /**
     * 文件上传成功回调
     * @param {Object} res - 服务端返回的数据
     * @param {File} file - 上传的文件对象
     */
    handleUploadSuccess(res, file) {
      if (res && res.data) {
        const fileData = res.data[0];
        this.$http({
          url: '/master/product/uploadProductAgreementContract',
          type: 'put',
          params: {
            id: this.currentRow.productAgreementId || '',
            fileUrl: JSON.stringify([
              {
                name: fileData.name,
                url: fileData.wwwurl || ''
              }
            ]),
            companyCode: this.currentRow.companyCode || ''
          }
        }).then(res => {
          // 更新当前行的协议URL
          this.getList();
          this.$message.success('上传成功');
        });
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },

    /**
     * 文件上传失败回调
     * @param {Error} err - 错误对象
     * @param {File} file - 上传的文件对象
     */
    handleUploadError(err, file) {
      console.error('文件上传失败:', err);
      this.$message.error('文件上传失败，请重试');
    }
  }
};
</script>

<style lang="scss" scoped>
/* 弹窗样式继承自 my-dialog-template 基础样式 */
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;

  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }

  .el-dialog__body {
    padding-top: 15px;
  }

  /* 提示文字样式 */
  .agreement-tips {
    color: #606266;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 20px;
    padding: 12px 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  /* 表格样式 */
  .el-table {
    max-height: calc(100vh - 350px);
    overflow-y: auto;

    &::before {
      display: none;
    }

    .el-table__empty-block {
      border-bottom: 1px solid #ebeef5;
    }

    .el-table__header-wrapper {
      position: sticky;
      top: 0;
      z-index: 5;
    }

    .el-table__body {
      width: 100% !important;
    }
  }

  /* 链接文字样式 */
  .link-text {
    color: #409eff;
    cursor: pointer;
    &:hover {
      color: #66b1ff;
      text-decoration: underline;
    }
  }

  /* 左边距 */
  .ml-10 {
    margin-left: 10px;
  }

  /* 底部按钮区域 */
  .dialog-footer {
    margin-top: 30px;
    text-align: center;

    .el-button {
      min-width: 100px;
    }
  }

  /* 隐藏上传组件 */
  .hidden-upload {
    display: none;
  }
}
</style>
